import React, { PureComponent } from 'react';
import './ParametersTable.css';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import { connect } from 'react-redux';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { getDonorUnitFromBundleMembers } from 'common/utils/helpers';
import { isGa2Device, isItBundle } from 'common/utils/deviceTwinUtils';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import { setSelectedParameters, handleSort, searchComponentFilteredDevicesV2 } from 'redux/actions';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { defaultParametersTableSearchBody, Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';
import { LOADING_CIRCLE } from 'common/utils/constants';

const parameters = {
  'Connection Status': (device, isBundle, bundledDU, bundleMembers) => {
    if (!isBundle) return device.connectionState;

    let membersConnectionState = 'Connected';

    for (let member of bundleMembers) {
      if (member.connectionState === 'Disconnected') {
        membersConnectionState = 'Disconnected';
        break;
      }
    }

    return membersConnectionState;
  },
  //Reintroduce after
  // 'Software Version': (device, isBundle, bundledDU, bundleMembers) => {
  //   if (!isBundle) return getDeviceSwVersion(device);

  //   let lowestSwVersion = getDeviceSwVersion(bundledDU);

  //   bundleMembers &&
  //     bundleMembers.forEach((member) => {
  //       let curVersion = getDeviceSwVersion(member);
  //       if (curVersion.toLowerCase() !== 'unknown' && lowestSwVersion > curVersion) lowestSwVersion = curVersion;
  //     });

  //   return lowestSwVersion;
  // },
  'Admin State': (device, isBundle, bundledDU, bundleMembers) => {
    if (!isBundle)
      return device.properties && device.properties.reported && device.properties.reported.adminState
        ? device.properties.reported.adminState
        : null;

    return bundledDU.properties && bundledDU.properties.reported && bundledDU.properties.reported.adminState
      ? bundledDU.properties.reported.adminState
      : null;
  },
  'Last Reset Reason': (device, isBundle, bundledDU, bundleMembers) => {
    if (!isBundle)
      return device.properties && device.properties.reported && device.properties.reported.lastResetReason
        ? device.properties.reported.lastResetReason
        : null;

    return bundledDU.properties && bundledDU.properties.reported && bundledDU.properties.reported.lastResetReason
      ? bundledDU.properties.reported.lastResetReason
      : null;
  }
};

const columns = (parent) => [
  {
    Header: (col) => {
      return (
        <div className="ParametersTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Device ID'}
            reverse
            onClick={() => parent.props.dispatch(handleSort(parent.props.activeTab, 'parametersTable', 'deviceId'))}
          />
        </div>
      );
    },
    id: 'parameters_device_col_id',
    accessor: (device) => {
      return isItBundle(device) ? device.name : device.id;
    },
    Cell: (row) => {
      let device = row.original;
      const isBundle = isItBundle(device);
      const isGa2 = isGa2Device(device);
      const url = isGa2
        ? `/console/devices/pivot/overview?deviceId=${device.id}`
        : `/console/devices/detail?${device.deviceId}`;
      if (isBundle) device = getDonorUnitFromBundleMembers(device.members);

      return (
        <div className="ParametersTable_Id_Cell">
          <Link to={url}>{row.value}</Link>
        </div>
      );
    }
  },
  {
    Header: (col) => {
      return (
        <div className="ParametersTable_Header_OuterDiv ParametersTable_Header_OuterDiv_NoHover">
          <div className="ParametersTable_Parameter_Header_InnerDiv">
            <div className="ParametersTable_Parameter_Header_Dropdown_Div">
              <Dropdown
                title={parent.props.selectedParameters[0]}
                data={Object.keys(parameters)}
                selectItem={(item) => {
                  parent.props.dispatch(setSelectedParameters(parent.props.activeTab, [item]));
                }}
              />
            </div>
          </div>
        </div>
      );
    },
    id: 'parameters_selected_param_col_id',
    accessor: (device) => {
      let isBundle = isItBundle(device);
      let bundleMembers = isBundle ? device.members : [];
      let bundledDU = isBundle ? getDonorUnitFromBundleMembers(bundleMembers) : null;

      try {
        return parameters[parent.props.selectedParameters[0]](device, isBundle, bundledDU, bundleMembers);
      } catch (e) {
        console.log(e, 'params:', parent.props.selectedParameters);
        return '';
      }
    },
    Cell: (row) => {
      let value = row.value;
      if (parent.props.selectedParameters[0] === 'Connection Status') {
        return (
          <div
            className={classNames({
              ParametersTable_Param_Div: true,
              ParametersTable_Param_Offline_Div: value !== 'Connected'
            })}
          >
            {value === 'Connected' ? 'ONLINE' : 'OFFLINE'}
          </div>
        );
      }

      return <div className="ParametersTable_Param_Div">{value}</div>;
    }
  }
];

class ParametersTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sorted: []
    };

    this.columns = columns(this);
  }

  render() {
    let data = this.props.parametersTableDevices?.devices ?? [];
    if (data == null) {
      data = [];
    }

    let pageSize = data.length;

    let overlay = null;
    if (this.props.fetching) {
      overlay = <div className="ParametersTable_LoadingCircle_Overlay">{LOADING_CIRCLE}</div>;
    } else if (this.props.error && data.length < 1) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">Error </div>
            <div className="Global_Table_ErrorOverlay_Message">
              An unknown error occured while getting the list of devices. If this problem persists, please contact us at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
          </div>
        </div>
      );
    }
    let searchFilteredDeviceTableBody = {
      ...defaultParametersTableSearchBody,
      next: this.props.parametersTableDevices.continuationToken
    };

    return (
      <ScrollReactTable
        id={'parametersTable'}
        activeTab={this.props.activeTab}
        key={this.props.selectedParameters[0]}
        infiniteContainerHeight={357}
        showPagination={false}
        // withFixedColumns={true}
        resizable={false}
        sortable={false}
        minRows={11}
        overlay={overlay}
        className={'-highlight ParametersTable Global_Table'}
        defaultPageSize={0}
        searchComponent={'parametersTable'}
        pageSize={pageSize}
        infinite={true}
        searchFilteredDeviceTableBody={searchFilteredDeviceTableBody}
        hasMoreResults={this.props.parametersTableDevices?.hasMoreResults}
        filterDictionary={this.props.filterDictionary}
        fetchData={() => {
          this.props.dispatch(
            searchComponentFilteredDevicesV2(
              this.props.activeTab,
              'parametersTable',
              searchFilteredDeviceTableBody,
              this.props.filterDictionary,
              null,
              true
            )
          );
        }}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (handleOriginal) {
                handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
              }
            }
          };
        }}
        getTrProps={(state, rowInfo, column) => {
          if (rowInfo) {
            /* This will assign the class 'selected-row' to a row when it has been clicked on. This class is used to apply css style to the selected row*/
            return {
              className: 'rowStyle'
            };
          } else {
            return {};
          }
        }}
        data={data}
        columns={this.columns}
      />
    );
  }
}

export default connect((store) => {
  let selectedParameters;
  let parametersTableDevices;
  let filterDictionary = {};

  const activeTab = store.ui.devicesPage.activeTab;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    selectedParameters = store.ui.devicesPage.pivotTab.selectedParameters;
    parametersTableDevices = store.data.pivotDeviceSets?.parametersTable;
    filterDictionary = store.data.pivotFilterDictionary;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    selectedParameters = store.ui.devicesPage.echoTab.selectedParameters;
    parametersTableDevices = store.data.echoDeviceSets?.parametersTable;
    filterDictionary = store.data.echoFilterDictionary;
  } else {
    selectedParameters = store.ui.devicesPage.allDevicesTab.selectedParameters;
    parametersTableDevices = store.data.allDeviceSets?.parametersTable;
    filterDictionary = store.data.allDevicesFilterDictionary;
  }

  return {
    activeTab,
    selectedParameters,
    parametersTableDevices,
    filterDictionary,
    fetching: store.statuses['searchComponentFilteredDevicesV2_parametersTable_' + activeTab] === Status.PENDING,
    error: store.statuses['searchComponentFilteredDevicesV2_parametersTable_' + activeTab] === Status.FAILURE
  };
})(ParametersTable);
